import { useEffect } from 'react'
import { fireBusEvent } from '../lib/event-bus'

interface Task { id: string; prompt: string; runAt: number }

/** Listens for careless:task-fire events and invokes onFire with the task prompt. */
export function useTaskListener(onFire: (task: Task) => void, enabled: boolean = true) {
  useEffect(() => {
    if (!enabled) return
    const handler = (e: Event) => {
      const task = (e as CustomEvent).detail as Task
      if (task && task.prompt) {
        fireBusEvent({ source: 'scheduler', kind: 'fired', summary: `Task ${task.id}: ${task.prompt.slice(0, 80)}` })
        onFire(task)
      }
    }
    window.addEventListener('careless:task-fire', handler)
    return () => window.removeEventListener('careless:task-fire', handler)
  }, [onFire, enabled])
}
